// extracted by mini-css-extract-plugin
module.exports = {"component":"dropdown-component--2TfbB"};